import { NgModule } from '@angular/core';

import { DashboardModule as PlatformDashboardModule} from '@dx/platform-components';

import { DashboardRoutingModule } from './dashboard-routing.module';
import { DashboardComponent } from './dashboard.component';
import { SharedModule } from '../shared/shared.module';
import { FeaturedReportsComponent } from './featured-reports/featured-reports.component';

@NgModule({
  declarations: [ DashboardComponent, FeaturedReportsComponent ],
  imports: [
    PlatformDashboardModule,
    DashboardRoutingModule,
    SharedModule
  ],
  exports: [ DashboardComponent ]
})
export class DashboardModule { }
